import {createSelector} from "reselect";

const alerts = (state) => state.alerts;

const getAlertListData = createSelector(alerts, (alerts) => alerts?.alertsListData || {});

export const getAlertsList = createSelector(getAlertListData, (alertListData) => {
  if (alertListData?.results?.length > 0) {
    return alertListData?.results?.map((item) => ({
      ...item,
      appliance: item.inventory_name,
      type: item?.type === "deadman" ? "Downtime" : "Metric",
    }));
  } else {
    return [];
  }
});

export const getSensorAlertsList = createSelector(getAlertListData, (alertListData) => {
  if (alertListData?.results?.length > 0) {
    return alertListData?.results?.map((item) => ({
      ...item,
      appliance: item.inventory_name,
      type: item?.type === "deadman" ? "Sensor Downtime" : "Metric",
    }));
  } else {
    return [];
  }
});

export const getTotalCount = createSelector(
  getAlertListData,
  (alertListData) => alertListData.total_count
);

export const getPaginationUrls = createSelector(getAlertListData, (alertListData) => ({
  prevUrl: alertListData.previous,
  nextUrl: alertListData.next,
}));

export const getDowntimeCreateData = createSelector(
  alerts,
  (alerts) => alerts.downtimeCreateData || []
);

export const getMetricCreateData = createSelector(
  alerts,
  (alerts) => alerts.metricCreateData || []
);

export const getMetricFieldList = createSelector(
  alerts,
  (alerts) => alerts.metricFieldList || []
);

export const getSensorForAlert = createSelector(
  alerts,
  (alerts) => alerts.sensorsList || []
);

export const getGraphData = createSelector(alerts, (alerts) => alerts.graphData);

export const getAlertHistory = createSelector(alerts, (alerts) => alerts.history);

export const getHistoryPlot = createSelector(getAlertHistory, (alerts) => alerts);

export const getHistoryLogs = createSelector(alerts, (alerts) => {
  if (alerts.logs?.length > 0) {
    return alerts.logs.map((log) => ({
      ...log,
      timestamp: log._time,
      message: log._value,
      type: log._level,
    }));
  }
  return [];
});
